export default __webpack_public_path__ + "static/media/edge.dbdbceb3.png";